// extracted by mini-css-extract-plugin
export default {"stepperContent":"LOSConfigDialog_stepperContent__zJ3SO","stepper":"LOSConfigDialog_stepper__v1B73"};